export default "__VITE_ASSET__BNBWkUlR__"